import React from 'react';

/**
 * Stat card component for displaying metrics with an icon
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @param {string|number} props.value - Main metric value
 * @param {React.ReactNode} props.icon - Icon to display
 * @param {Object} [props.trend] - Optional trend data
 * @param {number} props.trend.value - Trend percentage value
 * @param {boolean} props.trend.isPositive - Whether trend is positive
 * @param {string} [props.className] - Additional CSS classes
 */
const StatCard = ({ title, value, icon, trend, className = '' }) => {
  return (
    <div className={`bg-white rounded-2xl shadow-card p-6 ${className}`}>
      <div className="flex items-center">
        <div className="p-2 rounded-xl bg-primary-light text-primary">{icon}</div>
        <div className="ml-4">
          <h3 className="text-sm font-medium text-gray-500">{title}</h3>
          <div className="flex items-center mt-1">
            <p className="xl:text-2xl font-semibold tertiary-text-color">{value}</p>
            {trend && (
              <span
                className={`ml-2 text-sm font-medium ${trend.isPositive ? 'text-success' : 'text-error'}`}
              >
                {trend.isPositive ? '+' : '-'}
                {trend.value}%
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
